import { render, staticRenderFns } from "./StudyConversationMessageEditorTextMobile.vue?vue&type=template&id=0f9e2c5b&scoped=true"
import script from "./StudyConversationMessageEditorTextMobile.vue?vue&type=script&lang=js"
export * from "./StudyConversationMessageEditorTextMobile.vue?vue&type=script&lang=js"
import style0 from "./StudyConversationMessageEditorTextMobile.vue?vue&type=style&index=0&id=0f9e2c5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9e2c5b",
  null
  
)

export default component.exports